/**
 * Checks if an object has any fields that are not equal to undefined.
 * @param obj - The object to be checked.
 * @returns True if the object has non-undefined fields, false otherwise.
 */
const objectHasNonUndefinedFields = <T extends object>(obj: T): boolean => {
    return objectHasDefinedFields(obj)
}

/**
 * Checks if an object has any fields that are not equal to undefined.
 * @param obj - The object to be checked.
 * @returns True if the object has non-undefined fields, false otherwise.
 *
 * Useful for checking form error states
 *
 */
const objectHasDefinedFields = <T extends object>(obj: T): boolean => {
    return Object.values(obj).some((value) => value !== undefined)
}

export { objectHasNonUndefinedFields, objectHasDefinedFields }
